import { TFunction } from '@gem/modules/i18n';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

export const chatUsersRemovedHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  const result: ISystemMessageText = { html: '' };

  if (presenter.isPublicGroup) {
    result.html = t('system_message_public_group_removed', {
      0: `<span class="system-message-title">${presenter.firstUserDisplayedName}</span>`,
      interpolation: { escapeValue: false },
    });
    result.sourceText = t('system_message_public_group_removed');
    result.params = {
      '{0}': { text: presenter.firstUserDisplayedName, userId: presenter.firstUserId },
    };
  } else {
    result.html = t('notification_removed_from_chat_users', {
      0: `<span class="system-message-title">${presenter.initiatorDisplayName}</span>`,
      1: `<span class="system-message-title">${presenter.firstUserDisplayedName}</span>`,
      interpolation: { escapeValue: false },
    });
    result.sourceText = t('notification_removed_from_chat_users');
    result.params = {
      '{0}': { text: presenter.initiatorDisplayName, userId: presenter.initiator?.id },
      '{1}': { text: presenter.firstUserDisplayedName, userId: presenter.firstUserId },
    };
  }

  return result;
};
